export default "__VITE_ASSET__BMyquYdr__"